"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PROPERTY_SETTLEMENT = exports.DIVORCE_SETTLEMENT = exports.CHILD_SUPPORT = exports.FAMILY_SPOUSAL_SUPPORT = exports.MAINTENANCE = exports.ALIMONY = exports.ROTH_IRA = exports.PROFIT_SHARING_PLAN = exports.PLAN_403B = exports.PLAN_401K = exports.PENSION = exports.IRA = exports.FRIEND = exports.FAMILY = exports.CROWD_FUNDING = exports.COMMUNITY_ORGANIZATION = exports.ROYALTIES = exports.RESIDUALS = exports.INTEREST = exports.DIVIDENDS = exports.VA_DISABILITY = exports.UNEMPLOYMENT = exports.TANF = exports.SUPPLEMENTAL_SECURITY_INCOME = exports.SOCIAL_SECURITY_DISABILITY_INSURANCE = exports.SOCIAL_SECURITY = exports.SNAP = exports.SECTION_8 = exports.OTHER_GOVERNMENT_ASSISTANCE = exports.LOCAL_HOUSING_VOUCHER = exports.LIHEAP = exports.LIFELINE_PHONE = exports.CHIP = exports.TEMPORARY = exports.PART_TIME = exports.FULL_TIME = exports.RENTAL_PROPERTY = exports.INDEPENDENT_CONTRACTOR = void 0; // BUSINESS

var INDEPENDENT_CONTRACTOR = 'independentContractor';
exports.INDEPENDENT_CONTRACTOR = INDEPENDENT_CONTRACTOR;
var RENTAL_PROPERTY = 'rentalProperty'; // EMPLOYEE

exports.RENTAL_PROPERTY = RENTAL_PROPERTY;
var FULL_TIME = 'fullTime';
exports.FULL_TIME = FULL_TIME;
var PART_TIME = 'partTime';
exports.PART_TIME = PART_TIME;
var TEMPORARY = 'temporary'; // GOVERNMENT

exports.TEMPORARY = TEMPORARY;
var CHIP = 'chip'; // child insurance/nutrition

exports.CHIP = CHIP;
var LIFELINE_PHONE = 'lifelinePhone';
exports.LIFELINE_PHONE = LIFELINE_PHONE;
var LIHEAP = 'liheap'; // home enegery subsidy

exports.LIHEAP = LIHEAP;
var LOCAL_HOUSING_VOUCHER = 'localHousingVoucher';
exports.LOCAL_HOUSING_VOUCHER = LOCAL_HOUSING_VOUCHER;
var OTHER_GOVERNMENT_ASSISTANCE = 'otherGovernmentAssistance';
exports.OTHER_GOVERNMENT_ASSISTANCE = OTHER_GOVERNMENT_ASSISTANCE;
var SECTION_8 = 'section8';
exports.SECTION_8 = SECTION_8;
var SNAP = 'snap';
exports.SNAP = SNAP;
var SOCIAL_SECURITY = 'socialSecurity';
exports.SOCIAL_SECURITY = SOCIAL_SECURITY;
var SOCIAL_SECURITY_DISABILITY_INSURANCE = 'socialSecurityDisabilityInsurance';
exports.SOCIAL_SECURITY_DISABILITY_INSURANCE = SOCIAL_SECURITY_DISABILITY_INSURANCE;
var SUPPLEMENTAL_SECURITY_INCOME = 'supplementalSecurityIncome';
exports.SUPPLEMENTAL_SECURITY_INCOME = SUPPLEMENTAL_SECURITY_INCOME;
var TANF = 'tanf';
exports.TANF = TANF;
var UNEMPLOYMENT = 'unemployment';
exports.UNEMPLOYMENT = UNEMPLOYMENT;
var VA_DISABILITY = 'vaDisability'; // INVESTMENT

exports.VA_DISABILITY = VA_DISABILITY;
var DIVIDENDS = 'dividends';
exports.DIVIDENDS = DIVIDENDS;
var INTEREST = 'interest'; // RESIDUALS_ROYALTIES

exports.INTEREST = INTEREST;
var RESIDUALS = 'residuals';
exports.RESIDUALS = RESIDUALS;
var ROYALTIES = 'royalties'; // OUTSIDE_CONTRIBUTOR

exports.ROYALTIES = ROYALTIES;
var COMMUNITY_ORGANIZATION = 'communityOrganization';
exports.COMMUNITY_ORGANIZATION = COMMUNITY_ORGANIZATION;
var CROWD_FUNDING = 'crowdFunding';
exports.CROWD_FUNDING = CROWD_FUNDING;
var FAMILY = 'family';
exports.FAMILY = FAMILY;
var FRIEND = 'friend'; // RETIREMENT

exports.FRIEND = FRIEND;
var IRA = 'ira';
exports.IRA = IRA;
var PENSION = 'pension';
exports.PENSION = PENSION;
var PLAN_401K = '401k';
exports.PLAN_401K = PLAN_401K;
var PLAN_403B = '403b';
exports.PLAN_403B = PLAN_403B;
var PROFIT_SHARING_PLAN = 'profitSharingPlan';
exports.PROFIT_SHARING_PLAN = PROFIT_SHARING_PLAN;
var ROTH_IRA = 'rothIra'; // SUPPORT

exports.ROTH_IRA = ROTH_IRA;
var ALIMONY = 'alimony';
exports.ALIMONY = ALIMONY;
var MAINTENANCE = 'maintenance';
exports.MAINTENANCE = MAINTENANCE;
var FAMILY_SPOUSAL_SUPPORT = 'familySpousalSupport';
exports.FAMILY_SPOUSAL_SUPPORT = FAMILY_SPOUSAL_SUPPORT;
var CHILD_SUPPORT = 'childSupport';
exports.CHILD_SUPPORT = CHILD_SUPPORT;
var DIVORCE_SETTLEMENT = 'divorceSettlement';
exports.DIVORCE_SETTLEMENT = DIVORCE_SETTLEMENT;
var PROPERTY_SETTLEMENT = 'propertySettlement';
exports.PROPERTY_SETTLEMENT = PROPERTY_SETTLEMENT;